const deps = ['Model'];

const factory = Model => {
  class Country extends Model {
    $resource = 'country';
    id = null;
    code = null;
    name = null;
    currencyId = null;
  }
  return Country;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular.module('bench.data.model.country', moduleDeps).factory('Country', factory);
